import { useMemo } from 'react';

// Takes an array of skus and returns price based on the variant price in kit that matches the sku
const useCalculatedKitSavingsByArray = (
  array: any[],
  kitPrice: number,
  products: Queries.KitCardFragmentFragment['products']
) => {
  // Calculate savings (all selected variants - kit price)

  const kitVariants = useMemo(
    () =>
      products
        ?.reduce((acc, c) => {
          if (!c?.variants) return acc;
          return [...acc, ...c?.variants];
        }, [] as (Queries.VariantDetailsFragmentFragment | null)[])
        .filter((v): v is Queries.VariantDetailsFragmentFragment => v !== null),
    [products]
  );

  const selectedVariantsPriceTotal = array
    .map((item) => kitVariants?.find((variant) => variant.sku === item)?.regularPrice)
    .reduce((acc: number, value) => {
      if (!value) return acc;
      if (isNaN(value)) return acc;
      return acc + Number(value);
    }, 0);

  return Math.max(0, selectedVariantsPriceTotal - kitPrice);
};

export default useCalculatedKitSavingsByArray;
